
import React from "react";
import Header from "@/components/Header";
import { useIsMobile } from "@/hooks/use-mobile";
import { EmptyState } from "@/components/EmptyState";
import { Settings as SettingsIcon } from "lucide-react";
import { Button } from "@/components/ui/button";

const Settings: React.FC = () => {
  const isMobile = useIsMobile();
  
  return (
    <div className="min-h-screen flex flex-col bg-background text-foreground">
      <Header />
      <main className="flex-1 container mx-auto px-4 py-6">
        <EmptyState
          icon={<SettingsIcon className="h-12 w-12 text-muted-foreground" />}
          title="Settings Feature Coming Soon"
          description="We're building a comprehensive settings panel to help you customize your experience."
          action={
            <div className="mt-2 text-sm text-muted-foreground">
              This feature will be available in the next update.
            </div>
          }
          className="min-h-[50vh]"
        />
      </main>
    </div>
  );
};

export default Settings;
